import { useEffect } from "react";

function allowBodyScroll(allow) {
	if (!allow) {
		document.body.style.setProperty("overflow", "hidden");
	} else {
		document.body.style.removeProperty("overflow");
	}
}

/**
 * Toggles the document.body's ability to scroll.
 *
 * @param {Boolean} isActive - whether the scroll lock should be enabled or disabled.
 */

function useLockBodyScroll(isActive) {
	useEffect(() => {
		// Disallow scroll if isActive, allow if not active.
		allowBodyScroll(!isActive);

		return () => {
			allowBodyScroll(true);
		};
	}, [isActive]);
}

export default useLockBodyScroll;



// WEBPACK FOOTER //
// ./src/shared/hooks/useLockBodyScroll.js